import clsx from "clsx";
import { ReactNode } from "react";

import { Icon } from "~/assets/icons/Icon";

import styles from "./Pill.module.scss";

type PillProps = {
  active: boolean;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
  /** When true, renders as a checkbox (square + checkmark). When false, as a radio (circle + dot). Defaults to true. */
  multi?: boolean;
  children: ReactNode;
};

const Pill = ({
  active,
  onClick,
  disabled,
  title,
  multi = true,
  children,
}: PillProps) => (
  <button
    type="button"
    className={clsx(styles.pillBase, active && styles.pillActive)}
    onClick={onClick}
    disabled={disabled}
    title={title}
  >
    <span className={styles.pillIcon}>
      {multi ? (
        active ? (
          <Icon iconName="CheckmarkIcon" width="0.875rem" height="0.875rem" />
        ) : (
          <span className={styles.pillSquare} />
        )
      ) : active ? (
        <span className={styles.pillDot} />
      ) : (
        <span className={styles.pillCircle} />
      )}
    </span>
    {children}
  </button>
);

export default Pill;
